// JsFromRoutes CacheKey 7b94927f5c044d44f7906da0d29447bd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  embed: definePathHelper('post', '/attachments/:record_type/:record_id/embed'),
}
